// extracted by mini-css-extract-plugin
export default {"layout":"Dashboard_layout__pvykV"};